import { useState, useEffect } from 'react';
import { FetchRequestTypes, useFetch } from '../../../hooks/useFetch';
import dayjs from 'dayjs';
import { DeparturesData, DeparturesDataItem } from '../interfaces/arrivalsDepartures.interfaces';

export const useDepartureData = (refresh: boolean, loadMore: boolean, dateSpan: Date[] | undefined) => {
  const [departuresUrl, setDeparturesUrl] = useState<string | null>(null);
  const [departuresData, setDeparturesData] = useState<DeparturesData | null>(null);
  const [departuresList, setDeparturesList] = useState<DeparturesDataItem[]>([]);
  const [noMoreToLoad, setNoMoreToLoad] = useState(false);

  const excludedImoNumbers = [
    '9864277',
    '9131199',
    '9200158',
    '9333917',
    '9390458',
    '9236315',
    '9346641',
    '8327105',
    '9631436',
    '9327475',
    '9327487',
    '9254977',
    '9407225',
    '9318230',
    '8412235'
  ];

  const {
    data: departuresLoadedData,
    loading: departuresLoading,
    error: departuresError,
  } = useFetch(departuresUrl, FetchRequestTypes.GET);

  const itemsToLoad = 20;

  useEffect(() => {
    if (refresh) {
      setDeparturesList([]);
      setDeparturesData(null);
      setNoMoreToLoad(false);

      if (!dateSpan) {
        const today = dayjs().hour(0).minute(0).toISOString();
        setDeparturesUrl(`/api-aad/web-backend/v1/departure?sortOrder=ASC&count=${itemsToLoad}&from=${today}`);
      } else {
        const from = dayjs(dateSpan[0]).hour(0).minute(0).second(0).toISOString();
        const to = dayjs(dateSpan[1]).hour(23).minute(59).second(59).toISOString();

        setDeparturesUrl(`/api-aad/web-backend/v1/departure?sortOrder=ASC&count=250&from=${from}&to=${to}`);
      }
    }
  }, [refresh]);

  useEffect(() => {
    if (loadMore) {
      const continuationToken = (departuresLoadedData as DeparturesData)?.continuationToken || '';
      setDeparturesUrl(
        `/api-aad/web-backend/v1/departure?sortOrder=ASC&count=${itemsToLoad}&continuationToken=${continuationToken}`
      );
    }
  }, [loadMore]);

  useEffect(() => {
    if (departuresLoadedData?.items?.length) {
      const listItems = (departuresLoadedData as DeparturesData).items;
      const filteredListItems = listItems
        .filter((item) => item.name.toLowerCase() !== 'portcontrol' && item.name.toLowerCase() !== 'port control')
        .filter((item) => !excludedImoNumbers.some((exclImo) => item.imo === exclImo));

      setDeparturesData(departuresLoadedData);

      if (loadMore) {
        setDeparturesList([...departuresList, ...filteredListItems]);
      } else {
        setDeparturesList([...filteredListItems]);
      }

      setDeparturesUrl(null);

      if (!departuresLoadedData.continuationToken) {
        setNoMoreToLoad(true);
      }
    }
  }, [departuresLoadedData]);

  useEffect(() => {}, [departuresLoading, departuresError]);

  return {
    departuresList,
    noMoreToLoad,
    departuresLoading,
    departuresError,
  };
};

